module.exports = __webpack_public_path__ + "static/media/4.3b56d2d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/galaxyRewards/4.png
// module id = 2072
// module chunks = 0